{
  "RRSP": "RRSP",
  "TFSA": "TFSA",
  "PERSONAL": "Cash",
  "RESP": "RESP",
  "RESP_SINGLE": "Single RESP",
  "RESP_FAMILY": "Family RESP",
  "RESP_ADULT": "Adult RESP",
  "CORPORATE_CASH": "Corporate Cash",
  "CORPORATE_TRUST": "Trusts",
  "CORPORATE_ESTATE": "Corporate Estate",
  "CORPORATE_CHARITY": "Corporate Charity",
  "RRSP_SPOUSAL": "Spousal RRSP",
  "LIRA": "LIRA",
  "RRIF": "RRIF",
  "RIF_SPOUSAL": "Spousal RRIF",
  "LIF": "LIF",
  "PRIF": "PRIF",
  "GRSP": "GRSP",
  "CASH_JOINT": "Joint Cash",
  "RDSP": "RDSP",
  "RDSP_JOINT": "Joint RDSP",
  "MARGIN": "Margin",
  "MARGIN_JOINT": "Joint Margin",
  "RESP_SINGLE_JOINT": "RESP Single Joint",
  "RESP_FAMILY_JOINT": "RESP Family Joint",
  "INFORMAL_TRUST": "Informal Trust",
  "INFORMAL_TRUST_JOINT": "Informal Trust Joint",
  "FHSA": "FHSA",
  "RLSP": "RLSP",
  "LRSP": "LRSP",
  "RLIF": "RLIF",
  "LRIF": "LRIF",
  "DBPP": "DBPP",
  "IPP": "IPP",
  "RPP": "RPP",
  "INVESTMENT": "Investment",
  "PENSION_PLAN": "Pension Plan",
  "DPSP": "DPSP",
  "GRSP_SPOUSAL": "Spousal GRSP",
  "USA_BROKERAGE": "Individual Brokerage",
  "USA_IRA": "Traditional IRA",
  "USA_RO_IRA": "Rollover IRA",
  "USA_RT_IRA": "Roth IRA",
  "USA_INH_IRA": "Inherited IRA",
  "USA_INH_RT_IRA": "Inherited Roth IRA",
  "USA_JT_WROS": "Joint Tenant Acct (JTWROS)",
  "USA_JT_JTBE": "Joint Tenants by Entirety",
  "USA_JT_TIC": "Joint Tenant (TIC)",
  "USA_JT_CP": "Joint Tenant (CP)",
  "USA_SEP_IRA": "Simplified Employee Pension IRA",
  "USA_401K": "401(k) Employer Sponsored",
  "USA_SOLO_401K": "Solo 401(k)",
  "USA_TRUST": "Trust Account",
  "USA_CORPORATE": "Corporate Account(s)",
  "USA_ESA": "Education Savings Account",
  "USA_529": "529 Savings Plan",
  "UK_BROKERAGE": "General Account",
  "UK_CASH_ISA": "Cash Individual Savings Account (ISA)",
  "UK_SS_ISA": "Stocks and Shares Individual Savings Account (ISA)",
  "UK_JISA": "Junior Individual Savings Account (JISA)",
  "UK_PERSONAL_PENSION": "Personal Pension",
  "USA_TOD": "Individual Brokerage - TOD",
  "USA_ESTATE": "Estate",
  "USA_DAF": "Donor Advised Fund",
  "USA_SIMPLE_IRA": "SIMPLE IRA",
  "USA_KEOGH": "Keogh Plan / HR-10",
  "USA_CUSTODIAL": "Custodial Account",
  "USA_IRA_CUSTODIAL": "Custodial (Minor) IRA",
  "USA_DBP": "Defined Benefit Plan",
  "USA_CRA": "Company Retirement Account / Pension Trust",
  "USA_MARGIN": "Individual Margin Account",
  "USA_JT_WROS_MARGIN": "Joint Tenant Margin Acct (JTWROS)",
  "USA_JT_TIC_MARGIN": "Joint Tenant Margin (TIC)",
  "USA_JT_JTBE_MARGIN": "Joint Tenants Margin by Entirety",
  "USA_JT_CP_MARGIN": "Joint Tenant Margin (CP)",
  "EXTERNAL": "External"
}
